<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-t-3 dsd-mt-md">{{ titre | translate }}</h1>
<div *ngIf="coordonneesClient">
  <dsd-alert
    variant="warning"
    tabindex="-1"
    aria-hidden="false"
    *ngIf="!etatModification && coordonneesClient.adresseClient.estChangementDiffere">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.warning' | translate }}</h2>
    <p>{{ 'caad.accueil.alerte.avertissementChangementEnCours' | translate }}</p>
  </dsd-alert>
  <dsd-alert
    variant="confirmation"
    tabindex="-1"
    aria-hidden="false"
    *ngIf="
      etatModification === 'succes' &&
      (!coordonneesClient.adresseClient.estChangementDiffere || !isFlowModificationAdresse)
    ">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.confirmation' | translate }}</h2>
    <p>{{ 'caad.accueil.alerte.succes' | translate }}</p>
  </dsd-alert>
  <dsd-alert
    variant="confirmation"
    tabindex="-1"
    aria-hidden="false"
    *ngIf="
      etatModification === 'succes' && coordonneesClient.adresseClient.estChangementDiffere && isFlowModificationAdresse
    ">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.confirmation' | translate }}</h2>
    <p>{{ 'caad.accueil.alerte.succesPostDate' | translate }}</p>
  </dsd-alert>
  <dsd-alert variant="error" tabindex="-1" aria-hidden="false" *ngIf="etatModification === 'erreur'">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.erreur' | translate }}</h2>
    <p>{{ 'caad.accueil.alerte.erreur.modification' | translate }}</p>
  </dsd-alert>
  <dsd-alert variant="error" tabindex="-1" aria-hidden="false" *ngIf="etatModification === 'erreurLimiteJournaliere'">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.erreur' | translate }}</h2>
    <p>{{ 'caad.accueil.alerte.erreur.limiteJournaliere' | translate }}</p>
  </dsd-alert>
  <dsd-alert variant="information" tabindex="-1">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.information' | translate }}</h2>
    <p [innerHtml]="'caad.accueil.alerte.changementAppliqueSeulement' | translate"></p>
  </dsd-alert>
  <dsd-container class="container-carte" *ngIf="coordonneesClient.comptesDetention">
    <h2 class="dsd-t-4 dsd-mb-md" *ngIf="coordonneesClient.comptesDetention?.length === 1">
      {{ 'caad.accueil.titreUneCarteLieeAuCompte' | translate }}
    </h2>
    <h2 class="dsd-t-4 dsd-mb-md" *ngIf="coordonneesClient.comptesDetention?.length > 1">
      {{ 'caad.accueil.titrePlusieursCartesLieesAuCompte' | translate }}
    </h2>
    <dsd-reveal-items [show]="isAppMobile || isWebMobile ? 1 : 3" type="all" selector="dsd-grid-col">
      <span slot="label">{{
        (isAppMobile || isWebMobile ? 'caad.accueil.libelle.carte' : 'caad.accueil.libelle.cartes') | translate
      }}</span>
      <div slot="items">
        <dsd-grid-row>
          <dsd-grid-col
            class="dsd-mb-md"
            *ngFor="let compteDetention of coordonneesClient.comptesDetention"
            sm-col="12"
            md-col="6"
            lg-col="4">
            <app-info-carte [infoCarte]="compteDetention.infosCarte"></app-info-carte>
          </dsd-grid-col>
        </dsd-grid-row>
      </div>
    </dsd-reveal-items>
  </dsd-container>

  <dsd-container *ngIf="coordonneesClient.comptesDetention?.length === 1">
    <ng-container *ngTemplateOutlet="adresseEtTelephone; context: { multiple: false }"></ng-container>

    <div
      *ngIf="coordonneesClient?.comptesDetention?.[0].infosCompte?.codeRelation === 'ADI'; else affichageCourrielSimple"
      class="info-block">
      <h3 class="libelle mb-08 dsd-b-20 dsd-fw-normal">{{ 'caad.accueil.libelle.adresseCourriel' | translate }}</h3>
      <p class="valeur dsd-mb-0">{{ 'caad.accueil.libelle.adresseCourrielAdditionnel' | translate }}</p>
    </div>

    <ng-template #affichageCourrielSimple>
      <div class="info-block dsd-mb-0">
        <h3 class="libelle mb-08 dsd-b-20 dsd-fw-normal">{{ 'caad.accueil.libelle.adresseCourriel' | translate }}</h3>
        <p class="valeur dsd-mb-md">
          {{
            coordonneesClient.comptesDetention?.[0].infosCompte?.adresseCourriel
              ? coordonneesClient.comptesDetention?.[0].infosCompte?.adresseCourriel
              : ('caad.accueil.libelle.adresseCourrielVide' | translate)
          }}
        </p>
        <dsd-button class="dsd-mb-0" variant="compact" (dsdButtonClick)="redirection(typeChangementEnum.COURRIEL)">
          {{
            (coordonneesClient.comptesDetention?.[0].infosCompte?.adresseCourriel
              ? 'caad.button.modifier'
              : 'caad.button.ajouterAccueil'
            ) | translate
          }}
          <span class="dsd-sr-only"
            > {{
              (coordonneesClient.comptesDetention?.[0].infosCompte?.adresseCourriel
                ? 'caad.accueil.libelle.horsEcran.adresseCourriel'
                : 'caad.accueil.libelle.horsEcran.uneAdresseCourriel'
              ) | translate
            }}</span
          >
        </dsd-button>
      </div>
    </ng-template>
  </dsd-container>

  <div *ngIf="coordonneesClient.comptesDetention?.length > 1">
    <dsd-container>
      <ng-container *ngTemplateOutlet="adresseEtTelephone; context: { multiple: true }"></ng-container>
    </dsd-container>

    <dsd-container>
      <h2 class="dsd-t-4 dsd-mb-md" tabindex="-1">{{ 'caad.accueil.titreCourriels' | translate }}</h2>
      <div *ngFor="let compteDetention of coordonneesClient.comptesDetention; let last = last" class="info-block">
        <h3 class="dsd-b-20 valeur mb-08">
          {{ compteDetention.infosCarte.descriptionCourte | titlecase }}
           <span class="dsd-sr-only"
            >{{ 'caad.accueil.libelle.horsEcran.carteCreditTerminant' | translate
            }}{{ compteDetention.infosCarte.numeroCarte.substring(12, 16) }}</span
          >
        </h3>
        <p class="dsd-mb-0" *ngIf="compteDetention?.infosCompte?.codeRelation === 'ADI'; else affichageCourriel">
          <span class="libelle" aria-hidden="true"
            >{{ compteDetention.infosCarte.numeroCarte | masquerCarte }}&nbsp;</span
          >
          <span class="valeur">{{ 'caad.accueil.libelle.adresseCourrielAdditionnel' | translate }}</span>
        </p>
        <ng-template #affichageCourriel>
          <p class="dsd-mb-md">
            <span class="libelle" aria-hidden="true"
              >{{ compteDetention.infosCarte.numeroCarte | masquerCarte }}&nbsp;</span
            >
            <span class="valeur">{{
              compteDetention.infosCompte.adresseCourriel
                ? compteDetention.infosCompte.adresseCourriel
                : ('caad.accueil.libelle.adresseCourrielVide' | translate)
            }}</span>
          </p>
          <dsd-button
            variant="compact"
            (dsdButtonClick)="redirection(typeChangementEnum.COURRIEL, compteDetention)"
            [ngClass]="{ 'last-child': last }">
            {{
              (compteDetention.infosCompte.adresseCourriel ? 'caad.button.modifier' : 'caad.button.ajouterAccueil')
                | translate
            }}
            <span class="dsd-sr-only"
              > {{
                (compteDetention.infosCompte.adresseCourriel
                  ? 'caad.accueil.libelle.horsEcran.adresseCourrielSpecifique'
                  : 'caad.accueil.libelle.horsEcran.uneAdresseCourrielSpecifique'
                ) | translate
              }}
              {{ compteDetention.infosCarte.descriptionCourte | titlecase }}
              {{ 'caad.accueil.libelle.horsEcran.seTerminant' | translate }}
              {{ compteDetention.infosCarte?.numeroCarte.substring(12, 16) }}</span
            >
          </dsd-button>
        </ng-template>
      </div>
    </dsd-container>
  </div>

  <ng-template #adresseEtTelephone let-multiple="multiple">
    <h2 class="dsd-t-4" tabindex="-1">{{ 'caad.accueil.titreServiceCarteCredit' | translate }}</h2>
    <div class="info-block dsd-mb-md">
      <h3 class="libelle mb-08 dsd-b-20 dsd-fw-normal">{{ 'caad.accueil.libelle.adressePrincipale' | translate }}</h3>
      <p class="valeur line-adresse dsd-mb-md">{{ coordonneesClient.adresseClient | adresse }}</p>
      <dsd-button variant="compact" (dsdButtonClick)="redirection(typeChangementEnum.COORDONNEES)">
        {{ 'caad.button.modifier' | translate }}
        <span class="dsd-sr-only"> {{ 'caad.accueil.libelle.horsEcran.adressePostale' | translate }}</span>
      </dsd-button>
    </div>

    <div
      *ngIf="coordonneesClient.telephones.length <= 0; else numeroPresent"
      class="info-block"
      [ngClass]="{ 'dsd-mb-md': !multiple }">
      <h3 class="libelle mb-08 dsd-b-20 dsd-fw-normal">
        {{ 'caad.accueil.libelle.horsEcran.titreNumeroTelephone' | translate }}
      </h3>

      <dsd-alert variant="warning" class="mb-08" id="avis-num">
        <h4 slot="title">{{ 'caad.accueil.alerte.horsEcran.warning' | translate }}</h4>
        <p>
          {{ 'caad.accueil.alerte.avertissement1' | translate }}
          <strong>{{ 'caad.accueil.alerte.avertissement2' | translate }}</strong>
          {{ 'caad.accueil.alerte.avertissement3' | translate }}
        </p>
      </dsd-alert>

      <p class="dsd-mb-md">{{ 'caad.accueil.libelle.telephoneVide' | translate }}</p>

      <dsd-button
        variant="compact"
        (dsdButtonClick)="redirection(typeChangementEnum.TELEPHONE)"
        [ngClass]="{ 'dsd-mb-0': multiple }"
        described-by="avis-num">
        {{ 'caad.button.ajouterAccueil' | translate }}
        <span class="dsd-sr-only"> {{ 'caad.accueil.libelle.horsEcran.unNumero' | translate }}</span>
      </dsd-button>
    </div>

    <ng-template #numeroPresent>
      <div class="info-block">
        <h3 class="dsd-sr-only">{{ 'caad.accueil.libelle.horsEcran.titreNumeroTelephone' | translate }}</h3>
        <p *ngIf="telephonePrincipal" class="dsd-mb-md">
          <span class="libelle mb-08">{{ 'caad.accueil.libelle.telephone' | translate }}&nbsp;</span>
          <span class="valeur">{{ telephonePrincipal | phone }}</span>
        </p>
        <p *ngIf="telephoneSecondaire" class="dsd-mb-md">
          <span class="libelle mb-08">{{ 'caad.accueil.libelle.telephoneSecondaire' | translate }}&nbsp;</span>
          <span class="valeur">{{ telephoneSecondaire | phone }}</span>
        </p>
        <div *ngIf="telephoneEmployeur" class="two-column">
          <p class="dsd-mb-md">
            <span class="libelle mb-08">{{ 'caad.accueil.libelle.telephoneEmployeur' | translate }}&nbsp;</span>
            <span class="valeur">{{ telephoneEmployeur | phone }}</span>
          </p>
          <p *ngIf="telephoneEmployeur.numeroPoste" class="dsd-mb-md">
            <span class="libelle mb-08"> {{ 'caad.accueil.libelle.horsEcran.extension' | translate }}&nbsp;</span>
            <span class="valeur">{{ telephoneEmployeur.numeroPoste }}</span>
          </p>
        </div>

        <dsd-button
          variant="compact"
          (dsdButtonClick)="redirection(typeChangementEnum.TELEPHONE)"
          [ngClass]="{ 'dsd-mb-0': multiple }">
          {{ 'caad.button.modifier' | translate }}
          <span class="dsd-sr-only"
            > {{ 'caad.accueil.libelle.horsEcran.' + horsEcranNumeroTelephone | translate }}</span
          >
        </dsd-button>
      </div>
    </ng-template>
  </ng-template>
  <dsd-button
    *ngIf="isMembre"
    class="btn-precedent dsd-mb-md"
    (dsdButtonClick)="allerVersPrecedent()"
    full-width="xs"
    >{{ 'caad.button.precedent' | translate }}</dsd-button
  >
</div>

<div *ngIf="!coordonneesClient">
  <dsd-alert variant="inactive" tabindex="-1" *ngIf="etatErreur !== 'carte' && etatErreur !== 'acces'">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.erreur' | translate }}</h2>
    <p>{{ 'caad.accueil.alerte.erreur.' + etatErreur | translate }}</p>
  </dsd-alert>
  <dsd-container *ngIf="etatErreur === 'carte'">
    <h2 class="dsd-t-4 dsd-mb-md" tabindex="-1">{{ 'caad.accueil.erreur.carte.titre' | translate }}</h2>
    <p class="dsd-mb-0">
      {{ 'caad.accueil.erreur.carte.message' | translate }}
      <dsd-link
        ><a href="https://www.desjardins.com/particuliers/prets-marges-cartes-credit/cartes-credit/index.jsp">
          {{ 'caad.accueil.erreur.carte.lien' | translate }}
        </a></dsd-link
      >.
    </p>
  </dsd-container>
  <dsd-container *ngIf="etatErreur === 'acces'">
    <h2 class="dsd-t-4 dsd-mb-md" tabindex="-1">{{ 'caad.accueil.erreur.acces.titre' | translate }}</h2>
    <p class="dsd-mb-0" [innerHtml]="'caad.accueil.erreur.acces.' + typeMessageErreur | translate"></p>
  </dsd-container>
</div>

<app-bouton-retour *ngIf="!estBancaireActif()"></app-bouton-retour>

<!--A supprimer si dsd deploie une solution de prechargement de composant,
 mais cest ici juste pour permettre aux composants dsd de load avant le retour des apis.-->
<app-dsd-prefetch-components *ngIf="coordonneesClient"></app-dsd-prefetch-components>
